import styled from 'styled-components';

import { media } from '@theme/media';

export const Input = styled.input`
  background-color: transparent;
  padding: 9px 0 9px 18px;
  font-size: 14px;
  line-height: 1.4em;
  letter-spacing: 0.02em;
  font-weight: 500;
  width: 100%;
  border: none;
  appearance: none;
  outline: none;

  ${media.tablet} {
    padding: 0 0 1px 6px;
  }
`;
